// extracted by mini-css-extract-plugin
export default {"table":"TableDatiUtente_table__Aui6i","testo":"TableDatiUtente_testo__9GIZ4","testoDenominazione":"TableDatiUtente_testoDenominazione__TOjkD"};